var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient0, _linearGradient1, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportWhiteboardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "support_whiteboard_icon_svg__uuid-ff24f0f1-eed2-4836-9798-2d51d7c2844c",
    "data-name": "j",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 377.61 477.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-95440de4-f935-4f13-bc73-9ae38b68344b",
    x1: 132.77,
    y1: 333.51,
    x2: 214.35,
    y2: 394.98,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#5543e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#8d31ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#b922b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#d918a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#ed129e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4109b"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-45a1511f-5948-48f9-ab57-f0b9ce506398",
    x1: 149.4,
    y1: 400.52,
    x2: 222.91,
    y2: 423,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c2eae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8c2eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b0099"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-54f0ad03-f9b5-4a73-b382-b3b7f81cbede",
    x1: 476.96,
    y1: -1593.04,
    x2: 510.84,
    y2: -1655.62,
    gradientTransform: "translate(-1372.05 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60f97"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-ca5906bb-1f84-497e-b3d2-15ab285f8703",
    x1: 206.92,
    y1: 450.21,
    x2: 214.33,
    y2: 450.21,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a44fc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c25b8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "support_whiteboard_icon_svg__uuid-3ef65922-0e21-480b-a913-e3e11d57229f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m189.04,167.3l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "support_whiteboard_icon_svg__uuid-f64e248c-b8d0-44d6-8182-b274944a96ed"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m189.04,167.3l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z",
    style: {
      clipPath: "url(#support_whiteboard_icon_svg__uuid-3ef65922-0e21-480b-a913-e3e11d57229f)",
      fill: "none"
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-c5da058f-3dd7-4fbc-9b40-7fa4e296b0a0",
    x1: -59.87,
    y1: 173.23,
    x2: 213.75,
    y2: 379.42,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4109b"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-bb72de4f-3033-4502-8fbe-62a211f73013",
    x1: 842.84,
    y1: -2167.43,
    x2: 1158.52,
    y2: -2080.85,
    gradientTransform: "translate(-2142.48 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e67eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fa4bd"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-3833fe0f-6871-410b-88a6-e609227456e0",
    x1: -66.29,
    y1: 181.75,
    x2: 207.33,
    y2: 387.94,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4109b"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-c8405d16-3ff2-47e8-aac4-8a3a604e69fc",
    x1: 843.39,
    y1: -2169.41,
    x2: 1159.07,
    y2: -2082.83,
    gradientTransform: "translate(-2142.48 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2e67eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fa4bd"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-43e35eea-dff2-4a3b-b3e6-c0ad2f04ac52",
    x1: 3323.66,
    y1: 2205.43,
    x2: 3549.38,
    y2: 2267.33,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#148c17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11f2df"
  }))), _linearGradient0 || (_linearGradient0 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-60dff860-d620-443b-8c19-c342a97bcf00",
    x1: 3335.19,
    y1: 2191.4,
    x2: 3582.88,
    y2: 2259.34,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#107027"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12ab6b"
  }))), _linearGradient1 || (_linearGradient1 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-da2e32fc-3482-405c-a391-ca1ce3ccaa2d",
    x1: 170.3,
    y1: 93.11,
    x2: 354.57,
    y2: 93.11,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59d624"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-6e9cc514-1a9f-4361-ba28-b797b9ee8e65",
    x1: 254.7,
    y1: 87.48,
    x2: 161.28,
    y2: 87.48,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59d624"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-19008cc5-65f8-4099-b070-ee4fcf5d26e0",
    x1: 3263.5,
    y1: 2284.72,
    x2: 3595.5,
    y2: 2375.77,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4431d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d42db8"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-7fc60172-c3e9-46b6-b39d-7fac6ba71450",
    x1: 3339.5,
    y1: 2423.29,
    x2: 3458.25,
    y2: 2423.29,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4931fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a817fc"
  }))), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-f3a85381-61b0-48f9-9a48-6d59e0dd2b3a",
    x1: -168.86,
    y1: 10.75,
    x2: 289.8,
    y2: 356.37,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#374df2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f410ce"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-8a3f7c18-10ff-4678-a4c5-3bde73762104",
    x1: 242.77,
    y1: 274.95,
    x2: 266.99,
    y2: 293.19,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660743"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-8c3fe15f-a7e2-4141-bedd-647a17ba7c70",
    x1: 3270.96,
    y1: 2261.66,
    x2: 3585.81,
    y2: 2348.01,
    gradientTransform: "translate(-2150.43 3704.77) rotate(-21.66) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3c38f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11bdd8"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-737db38f-b893-4a7c-bb2b-523899a328f8",
    x1: 242.21,
    y1: 275.88,
    x2: 268.11,
    y2: 295.4,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660743"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-bd6a5c4b-ec89-45ce-8598-1530215e5447",
    x1: 241.73,
    y1: 275.41,
    x2: 266.34,
    y2: 293.95,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#402a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a11d70"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-30d1513f-2bf0-48c1-b199-c57ced9880e8",
    x1: 431.46,
    y1: -1546.91,
    x2: 462.81,
    y2: -1604.82,
    gradientTransform: "translate(-1372.05 698.45) rotate(52.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e60f97"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "support_whiteboard_icon_svg__uuid-ba01bc00-fbf0-4e99-be49-96ea40ef3ba9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132.03,160.13l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "support_whiteboard_icon_svg__uuid-289c6133-04cd-430e-9b40-7cabc119dd0c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m132.03,160.13l.07.29h0c.1.45-.18.89-.62.99-.4.09-.79-.12-.95-.49l-.12-.28,1.62-.52h0Z",
    style: {
      clipPath: "url(#support_whiteboard_icon_svg__uuid-ba01bc00-fbf0-4e99-be49-96ea40ef3ba9)",
      fill: "none"
    }
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-2fdcfc40-c1f1-4957-91ad-35d5dccf46f4",
    x1: 100.91,
    y1: 323.55,
    x2: 151.61,
    y2: 442.99,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8c2eae",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#8c2eae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b0099"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-1f5f782a-6fb7-46e7-9f20-1579b63e1e30",
    x1: 177.37,
    y1: 437.44,
    x2: 208.66,
    y2: 437.44,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c25b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a44fc2"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-986e86bc-e059-47ca-a4cb-2707c224782f",
    x1: 110.9,
    y1: 439.54,
    x2: 150.32,
    y2: 439.54,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c25b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a44fc2"
  }))), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-bfa9ca60-346f-42d9-ace6-5a014a02e11b",
    x1: 148.58,
    y1: 456.52,
    x2: 155.33,
    y2: 456.52,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a44fc2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7c25b8"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-9634d6d8-44ec-4e79-b106-6113a025adf7",
    x1: 61.81,
    y1: 113.33,
    x2: 369.53,
    y2: 197.74,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5730d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0fa4bd"
  }))), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-b76e7de9-c3c4-48ef-befe-a11adfabb278",
    x1: 88.07,
    y1: 38.73,
    x2: 349.62,
    y2: 235.82,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#598cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45e4ff"
  }))), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-599a5368-c333-4489-a6f7-b22f44fa43b3",
    x1: 352,
    y1: 215.76,
    x2: 379.62,
    y2: 236.56,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#170f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#660743"
  }))), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-bbe542e5-75be-414d-a9d9-3114823b3685",
    x1: 358.23,
    y1: 219.22,
    x2: 381.05,
    y2: 236.42,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#402a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a11d70"
  }))), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-bc9e46ee-a48a-447e-b740-abc125afee1a",
    x1: 78.89,
    y1: 135.22,
    x2: 229.04,
    y2: 135.22,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4076ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42e5ff"
  }))), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-71cc5d2d-9ffe-4f2d-97a2-32de33575ae1",
    x1: 115.41,
    y1: 41.31,
    x2: 171.21,
    y2: 41.31,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ffac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59d624"
  }))), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-979588ef-ac0a-4826-b7ed-ff84c956a21f",
    x1: 78.55,
    y1: 70.36,
    x2: 114.82,
    y2: 70.36,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#598cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e91fb"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-a3a517c9-6f44-4172-9959-fbb3fdd7b395",
    x1: 50.78,
    y1: 95.28,
    x2: 79.55,
    y2: 95.28,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#598cff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e91fb"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "support_whiteboard_icon_svg__uuid-306cd40b-e3df-4a68-8a4e-bd4773090d8c",
    x1: 50.95,
    y1: 209.7,
    x2: 345.27,
    y2: 209.7,
    gradientTransform: "translate(0 477.68) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#617ef2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f478ab"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m206.87,60.18c-.02-.19-.04-.38-.04-.59-.02-2.78.42-5.02,1.57-7.56.23-.5.46-1,.69-1.5-1.13-.9-2.26-1.78-3.3-2.76-15.51,10.65-55.31,47.73-58.58,76.32,6.04,4.1,30.95,19.95,38.31,20.82.37.04.74.1,1.11.14-.08-.5-.16-1-.24-1.51-2.91-19.68,4.64-40.15,20.48-83.37h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-95440de4-f935-4f13-bc73-9ae38b68344b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.54,117c6.57-47.51,41.16-68.36,21.21-108.89-3.55,15.78-8.39,30.42-16.22,44.4-8.61,16.13-24,29.12-33.79,46.77-1.53,6.08,2.8,11.84,8.72,18.47,6.69-.44,13.37-.87,20.08-.75Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-45a1511f-5948-48f9-ab57-f0b9ce506398)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m190.4,164.62c9.35,1.78,18.75,3.37,28.24,4.07,4.39.32,8.89.49,13.34.23.77-.8,1.54-1.59,2.3-2.4-3.5-10.43-9.12-22.31-8.53-36.38,1.73-41.12-3.87-60.47-11.88-93.82-.03,0-2.06,10.51-2.11,10.49-26.11,49.86-28.75,72.26-25.37,96.75,1.04,7.56,2.4,14.56,4.01,21.07h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-54f0ad03-f9b5-4a73-b382-b3b7f81cbede)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m211.8,46.81c.72-3.22,1.05-6.51,1.09-9.78.06-3.28-.17-6.55-.64-9.78-.46-3.24-1.33-6.39-2.06-9.56-.74-3.18-1.64-6.31-2.52-9.53l.17-.08c1.82,2.82,3.12,5.93,4.12,9.12,1.01,3.2,1.43,6.55,1.74,9.87.3,3.33.35,6.68.1,10-.28,3.32-.86,6.61-1.82,9.78l-.18-.05h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-ca5906bb-1f84-497e-b3d2-15ab285f8703)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.02,36.3c.28,5.68-2.28,10.99-4.44,16.1-2.25,5.11-5.06,9.98-7.31,15.07-2.2,4.92-4.5,10.38-6.41,15.45-8.6,21.88-12.07,41.78-7.51,65.06.94,5.47,1.97,10.92,3.27,16.31l-1.15-1.03c6.58.96,13.32.64,19.95-.07,6.8-.65,13.48-2.32,19.93-4.02.02.07,0,.14-.07.17-3.09,1.45-6.33,2.52-9.6,3.48-3.28.91-6.62,1.66-9.99,2.25-6.78,1.16-13.69,1.59-20.57.89-.58-.06-1.03-.49-1.15-1.03-1.38-5.45-2.55-10.97-3.37-16.53-2.87-16.68-1.89-34.03,3.33-50.16,4.13-13.42,9.84-26.26,16.35-38.64,2.58-4.93,5.14-9.91,6.98-15.17.87-2.62,1.66-5.36,1.47-8.12,0-.08.05-.15.13-.15.07,0,.14.05.15.13h0Z",
    style: {
      fill: "#c43dd9"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m230.11,159.27c-1.84-4.37-3.7-8.8-4.69-13.56-2.59-14.14-.05-28.53-.93-42.75-.44-18.78-5.13-38.48-8.3-56.2-.35-1.48-.86-3.68-1.2-5.17-.33-1.42-.86-3.75-1.21-5.16v-.04s.02.07.07.05c-.07-.02-.11-.1-.09-.17s.1-.11.17-.09c.05,0,.11.13.1.13,0,.02.03.1.03.13l.04.16c.05.18.19.79.24.98.19.79.73,3.1.92,3.94.34,1.48.84,3.64,1.18,5.08,0,.04.02.09.03.12.03.05-.05-.1-.12-.06l.13.11c4.11,18.53,9.23,37,10.21,56.07.64,9.51.82,19.07.3,28.55-.23,4.7-.27,9.37.32,13.99.59,4.61,1.91,9.18,3.05,13.8.05.15-.2.24-.26.09h.01Z",
    style: {
      fill: "#c43dd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.46,239.32c.65,1.56,2.12,3.26,1.99,5.49-.12,2.07-1.93,9.76-3.52,13.76,0,0,1.17-11.32,1.11-14.77-.03-1.68.43-4.49.43-4.49h0Z",
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#support_whiteboard_icon_svg__uuid-f64e248c-b8d0-44d6-8182-b274944a96ed)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.82,171.15l.26-.08.26-.08.26-.08.26-.08s6.33,18.56-.74-3.23l-.2-.87-.43.14-.43.14-.43.14-.43.14.35.83c7.07,21.78,1.28,3.05,1.28,3.05v-.02Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".23px"
    }
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 13,
    transform: "translate(186.83 165.84)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAANCAYAAACKCx+LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAH0lEQVQYlWNgYGBgmK29gnm29gpmBmQAE8CQGAXoAADiuQXF6DzhnwAAAABJRU5ErkJggg==",
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m129.81,134.62h0c0-.07-.02-.13-.02-.2,0,.06,0,.12.02.19h0Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m135.08,157.72h0c-.12-.03-.25-.05-.37-.07.12.02.25.05.37.07Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-c5da058f-3dd7-4fbc-9b40-7fa4e296b0a0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.18,157.55c.18.03.35.07.53.1-.18-.03-.35-.07-.53-.1h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-bb72de4f-3033-4502-8fbe-62a211f73013)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.18,157.55c.18.03.35.07.53.1.12.02.25.05.37.07-2.19-7.07-4.04-14.78-5.27-23.11,1.13,8.23,2.61,15.85,4.37,22.93h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-3833fe0f-6871-410b-88a6-e609227456e0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m134.18,157.55c.18.03.35.07.53.1.12.02.25.05.37.07-2.19-7.07-4.04-14.78-5.27-23.11,1.13,8.23,2.61,15.85,4.37,22.93h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-c8405d16-3ff2-47e8-aac4-8a3a604e69fc)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m171.7,415.21c1.74-20.83,1.49-72.45,44.96-97.66,34.2-19.84,80.96-17.81,103.43-18.64-14.79-2.58-92-12.79-112.87-5.21-16.33,5.93-67.25,31.56-87.24,58.82-7.57,10.32.7,19.81-6.06,29.43,11.43,73.19,57.06,95.89,57.06,95.67,0-.06,0-.1-.02-.16-6.31-27.73-.25-50.32.74-62.26h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-43e35eea-dff2-4a3b-b3e6-c0ad2f04ac52)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m145.99,118.83c-3.86,3-7.48,6.16-10.91,9.42.57.6,1.09,1.28,1.56,1.95.19.28,1.16,1.64,1.48,2.34.6-.04,1.71.07,2.02.06,1.18-.02,2.36-.05,3.55-.06,2.12-.02,4.24-.06,6.36-.1,5.37-3.37,8.61-4.79,8.61-4.79,0,0,7.76-29.78,19.38-55.32-6.07,5.91-30.02,35.46-32.05,46.49h0Z",
    style: {
      fill: "#38004f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m302.66,346.33c26.7,4.25,23.22,11.81,29.8,5.45,22.48-21.74,22.96-60.31,19.56-60.31-6.41,5.95-13.8,3.2-19.31,3.74-65.3,6.5-81.36,2.73-115.81,21.82-43.92,24.34-66.88,83.72-45.95,160.44.02.06,0,.1.02.16,32.96-30.06,41.08-145.73,131.68-131.3h.01Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-60dff860-d620-443b-8c19-c342a97bcf00)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.98,477.63c2.27-2.15,4.27-4.56,6.1-7.09,1.83-2.52,3.5-5.16,5.06-7.87,3.1-5.42,5.82-11.04,8.4-16.72,5.2-11.35,9.98-22.91,15.32-34.24,5.31-11.33,11.27-22.44,18.65-32.65,7.36-10.17,16.36-19.44,27.4-25.78,2.74-1.59,5.62-2.95,8.56-4.12,2.93-1.2,5.98-2.12,9.05-2.89,3.08-.77,6.21-1.26,9.35-1.63,3.15-.3,6.31-.5,9.47-.43,6.32.06,12.61.82,18.78,2.04,3.09.61,6.16,1.35,9.18,2.3,3.01.96,5.98,2.17,8.78,3.61,1.38.66,2.82,1.56,3.88,1.28.56-.14,1.16-.54,1.73-1.01s1.14-.99,1.68-1.53c2.22-2.14,4.23-4.5,6.08-6.98,3.68-4.98,6.6-10.51,8.89-16.29,2.3-5.77,3.98-11.8,5.04-17.94.52-3.07.89-6.17,1.03-9.29.07-1.56.09-3.12-.01-4.67-.05-.78-.13-1.55-.29-2.32-.08-.38-.17-.76-.32-1.12-.15-.34-.34-.76-.75-.81.42.03.63.46.79.8.16.36.27.74.36,1.12.18.76.29,1.54.36,2.32.15,1.56.19,3.13.16,4.7-.06,3.13-.36,6.26-.81,9.36-.91,6.2-2.46,12.32-4.65,18.21-2.21,5.88-5.1,11.54-8.78,16.68-1.84,2.56-3.87,5-6.11,7.24-.55.56-1.13,1.12-1.76,1.65-.63.52-1.33,1.06-2.29,1.32-.48.13-1,.13-1.46.06-.47-.08-.88-.22-1.27-.37-.78-.31-1.48-.67-2.18-1-5.53-2.77-11.52-4.41-17.61-5.6-6.1-1.18-12.27-1.88-18.46-1.91-3.09-.05-6.18.16-9.25.47-3.06.38-6.11.87-9.1,1.63-2.98.77-5.94,1.66-8.78,2.85-2.86,1.15-5.64,2.49-8.3,4.04-10.75,6.1-19.62,15.12-26.92,25.11-7.35,10.02-13.23,21.06-18.74,32.25-5.49,11.21-10.42,22.7-15.82,33.99-2.73,5.63-5.59,11.21-8.83,16.57-3.26,5.33-6.93,10.51-11.6,14.69v-.03Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-da2e32fc-3482-405c-a391-ca1ce3ccaa2d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m254.52,302.82c-83.54,22.66-98.41,98.61-83.28,174.63l-.52.14c-25.42-72.98-.31-159.99,83.8-174.78h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-6e9cc514-1a9f-4361-ba28-b797b9ee8e65)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.76,257.55c1.88-2.94,3.1-6.31,4.17-9.71-1.72-.72-3.18-1.2-4.15-1.51-42.19-13.8-78.1-46.09-124.62-58.89-63.01-17.33-110.03,5.6-118.83,8.55-75.72,25.34-99.32,105.25-111.74,141.86.76.51.39,1.32.39,1.32,3.33.6,31.1-19.56,40.64-27.21,28.25-22.65,42.83-29.55,86.12-58.3,25.14-16.69,123.12-25.47,163.7-9.58,20.87,8.17,48.75,5.8,58.62,14.42h.43c1.64.07,3.27-.08,4.9-.23.1-.23.22-.47.37-.7v-.02Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-19008cc5-65f8-4099-b070-ee4fcf5d26e0)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.98,339.12c2.27-.33,4.28-1.86,6.29-2.93,6.01-3.63,11.79-7.64,17.47-11.77,7.42-5.67,15.14-11.06,21.76-17.66l.07.06c-5.94,7.31-13.79,12.79-21.41,18.2-5.77,4.02-11.63,7.94-17.76,11.41-2.08,1.03-4.11,2.53-6.44,2.78l.02-.09h0Z",
    style: {
      fill: "#617ef2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.97,299.89c2.92.9,2.76-3.43,1.49-3.32-.5.04-22.67-3.97-39.08-3.48-27.31.82-59.81,13.95-97.18,59.15-12.01,14.52-19.34,25.11-26.33,35.07,1.85,9.04,2.75,13.78,5.95,22.85,52.2-111.43,127.22-118.91,155.13-110.27h.02Z",
    style: {
      fill: "#38004f",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m110.28,195.77c-4.5,6.29-7.84,10.69-7.84,10.69,2.28-1.54,5.85-4.22,7.84-10.69Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-7fc60172-c3e9-46b6-b39d-7fac6ba71450)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m372.35,232.08c-14.98-10.08-30.9-12.86-47.52-28.58-16.77-15.86-28.11-53.29-28.11-53.29,0,0-80.24-54.96-149.5-39.16-.14.03-7.77,2.4-18.67,6.04l-.76.13c2.81-15.29,9.9-34.37,20.66-63.72,1.7.26,4.56-8.6,4.04-10.53-2.08-7.82-46.12,24.54-79.28,96.65C5.65,204.86-13.35,293.05,10.98,339.17c12.42-36.61,34.97-111.43,111.35-139.52,8.71-3.2,55.82-29.54,118.83-12.21,28.91,7.95,52.68,27.48,77.45,41.37,15.09,8.46,31.2,12.3,47.17,17.52.97.32,2.43.79,4.15,1.51.83-2.64,1.58-5.3,2.47-7.82.67-1.9,2.16-2.87,3.75-3.08-.68-1.85-1.86-3.55-3.81-4.86h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-f3a85381-61b0-48f9-9a48-6d59e0dd2b3a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.41,233.02c-12.44-7.92-26.88-12.25-39.03-20.76-8.22-5.53-15.47-12.69-20.58-21.2-7.82-12.61-13.41-26.43-17.89-40.53-30.79-19.38-70.65-37.77-109.37-41.37-13.05-1.45-26.79-.41-39.35,1.87,45.85-10.01,92.79,6.97,132.93,28.4,5.88,3.23,11.67,6.6,17.3,10.32,1.5,4.74,3.23,9.44,5.08,14.07,5.53,13.43,11.7,27.05,21.59,37.86,6.84,6.93,15.01,12.46,23.61,17.01,8.42,4.68,18.34,8.48,25.7,14.34h0Z",
    style: {
      fill: "#ff83ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.67,202.76c1.75-.76,1.58-2.82.77-5.54-1.26-4.21-7.83-12.83-15.85-16.22-6.42-2.71-28.1,3.21-27.79,6.6.08.86,4.35,8.15,17.67,15.45,6.19,3.39,14.28,1.51,18.37.58,4.96-1.13,5.24-.18,6.82-.87h.01Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-8a3f7c18-10ff-4678-a4c5-3bde73762104)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m172.31,272.26c10.98-4.63,41.74-17.15,78.9-11.33,33.54,5.25,37.32,15.74,63.15,16.43,23.06.62,39.88-13.06,46.77-17.83-8.76-9.87-38.02-6.98-59.69-15.46-40.59-15.88-79.73-25.16-127.23-16.28-57.41,10.74-119.69,81.36-122.6,84.16-2.95,2.84,1.21,89.45,27.19,114.66.02-.08.15-.02.17-.1,11.49-59.74,18.01-90.84,33.07-109.24,22.52-27.51,48.9-40.23,60.27-45.02h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-8c3fe15f-a7e2-4141-bedd-647a17ba7c70)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m178.23,227.55c-56.88,11.03-87.86,47.8-126.61,84.41-1.31,1.26-2.26,3.61.48,25.06,76.99-112.83,141.57-114.8,235.64-97.2,0,0-49.72-23.87-109.51-12.27h0Z",
    style: {
      fill: "#38004f",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.9
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m254.42,182.84c7.67,2.34,8.52,13.72,2.44,18.28.21-3.35.68-6.31.36-9.47-.3-3.18-1.35-5.77-2.8-8.81h0Z",
    style: {
      fill: "#ffd3e1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m257.36,177.66c-6.14-1.55-15.13-.53-22.26,1.91-4.37-.88-8.76-1.61-13.17-2.14-6.98-.85-14.01-1.27-21.01-1.28-1.82.03-3.63.05-5.45.08-5.18.19-10.34.54-15.46,1.12-6.92.79-13.79,1.93-20.56,3.44-6.77,1.5-13.46,3.34-20.03,5.48-6.57,2.16-13.04,4.61-19.36,7.4-2.75,1.2-5.52,2.51-8.14,3.79h-.02c-3.22,1.57-6.4,3.21-9.52,4.96-5.54,3.12-10.9,6.54-16.03,10.27-5.13,3.73-10.03,7.77-14.67,12.07-4.63,4.31-9,8.89-13.08,13.69-4.08,4.81-7.88,9.83-11.39,15.03s-6.76,10.57-9.74,16.07c-2.98,5.5-5.71,11.12-8.21,16.83-2.51,5.71-4.79,11.5-6.91,17.34s-4.06,11.74-5.92,17.66c0,0-1.82,5.93-5.46,17.78,4.22-11.66,6.32-17.48,6.32-17.48,2.14-5.81,4.37-11.59,6.76-17.29,2.38-5.7,4.94-11.33,7.69-16.84,2.75-5.52,5.71-10.92,8.9-16.17s6.62-10.34,10.29-15.24c3.67-4.89,7.6-9.58,11.77-14.03,4.17-4.44,8.59-8.63,13.23-12.55,4.65-3.9,9.52-7.53,14.58-10.84,5.06-3.32,10.32-6.32,15.73-9.02,3.04-1.52,6.14-2.92,9.26-4.26h.02c2.73-1.19,5.34-2.27,8.04-3.32,6.15-2.39,12.43-4.44,18.77-6.22,6.35-1.75,12.78-3.21,19.25-4.34,6.47-1.14,12.99-1.92,19.51-2.36,4.83-.33,9.67-.43,14.49-.39,1.69.05,3.38.1,5.06.15,6.5.3,12.96.98,19.34,2.06,3.59.6,7.15,1.34,10.67,2.19,5.22,5.57,13.24,12.19,20.51,13.97,12.6,3.08,28.45-2.37,28.45-2.37,0,0-1.7-21.97-22.25-27.15h0Z",
    style: {
      fill: "#f487e5",
      isolation: "isolate",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m274.73,197.08c-1.26-4.21-7.83-12.83-15.85-16.22-6.19-2.62-26.57,1.48-27.74,4.81-.04.12-.07.25-.06.37.08.86,4.36,9.57,17.68,16.86,6.19,3.39,14.28,1.51,18.37.58,4.96-1.13,5.24-.18,6.82-.87.91-.39,1.29-1.14,1.34-2.14.05-.93-.19-2.08-.58-3.4h.02Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-737db38f-b893-4a7c-bb2b-523899a328f8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.39,182.84c1.39,1.19,3.48,3.4,4.32,6.84,1.21,4.94-.85,9.49-1.88,11.44",
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.22,201.3c.01-1.15-.32-2.28-.68-3.38-.37-1.08-.94-2.1-1.55-3.08-1.23-1.96-2.71-3.75-4.32-5.4-1.6-1.66-3.35-3.17-5.24-4.47-.94-.66-1.92-1.24-2.93-1.76-.49-.28-1.03-.48-1.54-.72-.52-.25-.99-.37-1.53-.5-2.16-.41-4.48-.34-6.76-.15-1.14.08-2.28.21-3.43.36-1.14.13-2.28.28-3.42.48-2.28.33-4.54.79-6.78,1.32-1.12.27-2.23.59-3.29,1-.53.21-1.07.41-1.54.7-.45.29-.95.64-1.02,1.16l-.18.02c-.07-.69.46-1.21.89-1.61.46-.41.98-.72,1.5-1.03,1.05-.58,2.16-1.04,3.26-1.46,2.23-.83,4.52-1.43,6.84-1.9,2.32-.45,4.68-.76,7.06-.84,2.38-.06,4.78-.05,7.2.54.59.16,1.25.37,1.77.65.54.27,1.09.51,1.6.83,1.04.59,2.05,1.24,3,1.96,1.91,1.43,3.64,3.05,5.22,4.82,1.56,1.77,2.97,3.68,4.12,5.74,1.17,2.04,1.99,4.36,1.94,6.74h-.18v-.02Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-bd6a5c4b-ec89-45ce-8598-1530215e5447)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.05,160.44c14.61,1.89,30.64-2.72,39.93-17.19-3.5-10.43-3.93-3.22-4.57-17.29-1.9-41.64-11.5-94.32-11.56-94.33-26.11,49.86-31.18,83.26-27.81,107.75,1.04,7.56,2.4,14.56,4.01,21.07h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-30d1513f-2bf0-48c1-b199-c57ced9880e8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.27,383.13s.08-.06.12-.09c-.02-.01-.06-.02-.11-.04,0,.04,0,.09-.02.13h.01Z",
    style: {
      fill: "#0d2b30",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#support_whiteboard_icon_svg__uuid-289c6133-04cd-430e-9b40-7cabc119dd0c)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m131.81,163.98l.26-.08.26-.08.26-.08.26-.08s6.33,18.56-.74-3.23l-.2-.87-.43.14-.43.14-.43.14-.43.14.35.83c7.07,21.78,1.28,3.05,1.28,3.05v-.02Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: ".23px"
    }
  }), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 13,
    transform: "translate(129.83 158.84)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAANCAYAAACKCx+LAAAACXBIWXMAAAsSAAALEgHS3X78AAAAIklEQVQYlWNgYGBgmK29gnm29gpmBmQAE5itvYKJYRTgAwDhmQXE3oIBOwAAAABJRU5ErkJggg==",
    style: {
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m130.91,161.62c.77-.25.42-.95,1.19-1.2C109.05,71.46,174.8,54.21,149.41.05c-4.11,15.58-8.31,30.44-16.28,44.35-5.62,13.25-39.59,49.43-59.93,95.22-1.75,3.95,38.07,19.21,57.71,22h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-2fdcfc40-c1f1-4957-91ad-35d5dccf46f4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m207.84,8.13c-.85,5.91-2.49,11.68-4.31,17.35-1.88,5.67-4.03,11.24-6.39,16.73-2.36,5.49-4.86,10.94-7.99,16.06-1.57,2.55-3.21,5.07-5.05,7.44-.88,1.22-1.9,2.33-2.85,3.48-.47.58-1.03,1.09-1.56,1.63-.53.53-1.06,1.06-1.6,1.57l-.13-.13c3.65-4.71,6.71-9.76,9.6-14.93,2.87-5.16,5.71-10.37,8.23-15.74,2.52-5.37,4.82-10.85,6.86-16.42,2.04-5.57,3.91-11.23,5-17.08l.18.03h.01Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-1f5f782a-6fb7-46e7-9f20-1579b63e1e30)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.5.07c-1.25,7.05-3.28,13.95-5.66,20.71-2.42,6.74-5.2,13.36-8.31,19.83-3.11,6.46-6.46,12.83-10.45,18.82-4.02,5.95-8.37,11.71-13.41,16.82l-.14-.12c4.24-5.77,8.31-11.61,12.01-17.69,3.74-6.05,7.41-12.15,10.68-18.48,3.25-6.34,6.18-12.85,8.77-19.5,2.6-6.64,4.85-13.43,6.34-20.42l.18.03h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-986e86bc-e059-47ca-a4cb-2707c224782f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.21,42.27c.95-3.46,1.39-7.02,1.55-10.59.18-3.56.07-7.13-.27-10.68-.34-3.55-1.07-7.03-1.7-10.51-.65-3.49-1.46-6.93-2.45-10.41l.17-.08c1.92,3.09,3.17,6.57,4.07,10.09.91,3.53,1.19,7.18,1.37,10.8.17,3.62.09,7.25-.28,10.85-.41,3.59-1.1,7.17-2.29,10.57l-.17-.06v.02Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-bfa9ca60-346f-42d9-ace6-5a014a02e11b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.36,123.55c2.79-13.48,8.96-24.38,20.24-47.37-17.26,20.35-35.49,56.42-38.39,63.44-21.21,20.51-39.63,45.81-51.67,70.7,32.82-37.39,38.68-52.77,82.3-55.63,1.69-.11-17.61-12.67-12.48-31.15h0Z",
    style: {
      fill: "#38004f",
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m364.97,263.34c-.7-1.9-2.53-2.33-3.84-3.81-6.89,4.77-23.49,10.58-47.09,10.46-24.49-.13-39.9-6.2-62.84-9.06-37.32-4.66-87.19-8.42-139.16,56.35-16.85,21-29.66,48.09-33.16,109.29.06.01.06-.07.09-.05,27.84-20.9,32.41-38.45,62.36-74.67,37.37-45.2,69.87-58.33,97.18-59.15,33.93-1.02,59.85,16.95,77.14,16.02,17.66-.95,29.4-7.39,36.97-15.05,9.41-9.52,12.4-20.94,12.35-26.06,0-.08.33-3.36,0-4.27h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-9634d6d8-44ec-4e79-b106-6113a025adf7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.77,426.59c6.13-4.63,11.93-9.69,17.19-15.29,5.26-5.59,9.92-11.71,14.38-17.96s8.79-12.6,13.28-18.84c4.47-6.26,9.12-12.39,13.93-18.39,9.56-12.05,19.97-23.49,31.66-33.56,11.64-10.06,24.72-18.73,39.21-24.25,7.24-2.73,14.8-4.67,22.51-5.56,7.7-.9,15.52-.8,23.2.18,7.69.99,15.24,2.81,22.62,5.04,7.39,2.21,14.62,4.89,21.92,7.16,3.64,1.14,7.32,2.17,11.04,2.75,1.86.28,3.73.43,5.59.37,1.88-.12,3.79-.22,5.67-.47,7.54-.89,14.97-3.04,21.57-6.8,3.29-1.88,6.36-4.15,9.12-6.77,2.73-2.63,5.16-5.6,7.16-8.84,2.02-3.23,3.64-6.71,4.76-10.37.55-1.83.97-3.7,1.16-5.59.03-1.87.48-3.87.15-5.7l.17-.06c.26.98.16,1.94.15,2.91l-.08,1.43c0,.49,0,.97-.05,1.45-.13,1.93-.51,3.84-1.01,5.71-1.02,3.73-2.57,7.32-4.53,10.66-1.97,3.34-4.39,6.42-7.13,9.17-2.77,2.73-5.87,5.12-9.22,7.11-6.69,4.02-14.33,6.26-22.01,7.26-1.93.29-3.85.41-5.8.55-1.99.09-3.96-.05-5.9-.32-3.88-.56-7.64-1.57-11.34-2.68-7.38-2.3-14.57-4.96-21.91-7.16-7.32-2.22-14.77-4.01-22.33-4.99-7.55-1.01-15.22-1.17-22.79-.34-7.57.82-15.02,2.66-22.18,5.3-14.32,5.35-27.32,13.85-38.95,23.78-11.67,9.94-22.11,21.27-31.72,33.23-4.84,5.95-9.53,12.04-14.05,18.25-4.54,6.2-8.91,12.51-13.43,18.73-4.52,6.22-9.24,12.32-14.56,17.89-5.31,5.57-11.17,10.6-17.34,15.18l-.11-.15v-.02Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-b76e7de9-c3c4-48ef-befe-a11adfabb278)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.46,232.94s-4.92,7-11.8,12.48c-7.65,6.09-16.69,5.55-16.55,7.24.12,1.49,6.99.04,12.42,4.46,5.21,4.23,4.2,10.52,7.43,9.57,4.96-1.46,14.73-25.38,11.04-29.75-1.57-1.85-2.54-3.99-2.54-3.99h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-599a5368-c333-4489-a6f7-b22f44fa43b3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m365.12,266.6c.36-.03.68-.25.97-.5s.55-.54.8-.83c.49-.6.93-1.25,1.34-1.91.82-1.33,1.53-2.72,2.2-4.14,1.35-2.82,2.49-5.74,3.42-8.71.93-2.97,1.54-6.03,1.92-9.01.17-1.48.23-3.01-.21-4.3-.53-1.41-1.22-2.82-2.01-4.19l.14-.12c1.2,1.07,2.24,2.32,3.06,3.76.85,1.62.9,3.36.85,4.99-.16,3.31-1.28,6.36-2.37,9.34-1.13,2.98-2.46,5.87-3.99,8.65-.78,1.38-1.62,2.74-2.55,4.03-.47.64-.96,1.27-1.52,1.85-.28.29-.57.56-.9.81-.33.23-.7.46-1.14.47v-.18h-.01Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-bbe542e5-75be-414d-a9d9-3114823b3685)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m229.04,258.96c-45.04-.35-79.44,19.05-108.36,52.56-20.74,22.6-30.2,46.44-36.05,76.23-2.51,12.8-4.21,25.99-5.74,38.97.34-31.6,3.71-64.51,18.9-92.8,5.1-9.45,11.77-17.95,18.76-26.02,7.14-7.9,14.57-15.62,23.02-22.21,26.24-21.08,55.93-30.29,89.47-26.74h0Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-bc9e46ee-a48a-447e-b740-abc125afee1a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.12,230.37c-12.21,34.61-17.16,74.27-2.06,108.76.05.1-.11.19-.16.09-18.35-31.7-10.71-76.92,2.23-108.84h-.01Z",
    style: {
      fill: "#c43dd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.47,395.01l2.03,7.63c.69,2.54,1.39,5.07,2.33,7.54h0c.71,1.68,1.22,3.4,1.88,5.06.64,1.67,1.36,3.31,2.08,4.94,1.4,3.28,2.97,6.47,4.7,9.57,1.74,3.09,3.5,6.18,5.45,9.14,1.9,2.99,3.92,5.91,6.05,8.75,4.2,5.72,8.82,11.13,13.68,16.32,2.43,2.59,4.99,5.08,7.67,7.42,1.32,1.2,2.68,2.35,4.1,3.42.71.53,1.44,1.04,2.19,1.51.74.48,1.52.93,2.35,1.23l-.05.19c-1.77-.48-3.33-1.43-4.85-2.38-1.52-.97-2.97-2.04-4.39-3.15-2.83-2.22-5.52-4.63-8.1-7.13-5.16-5.02-9.9-10.47-14.21-16.24-4.28-5.79-8.1-11.92-11.32-18.37-3.21-6.44-5.8-13.22-7.46-20.22h0c-.93-2.46-1.64-5.01-2.33-7.55l-2.02-7.63.19-.05h.03Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-71cc5d2d-9ffe-4f2d-97a2-32de33575ae1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m78.8,426.69c3.43-2.75,6.83-5.53,10.03-8.54,3.22-2.98,6.28-6.13,9.16-9.44s5.54-6.79,8.22-10.27c2.71-3.45,5.27-7.03,8.06-10.44l.11-.14v.17l.02.17v.05s-.16.19-.16.19l-.08-.05.12-.2v.04l-.04-.17.12.03c-2.39,3.7-4.83,7.36-7.43,10.91-2.6,3.56-5.45,6.93-8.41,10.2-2.96,3.27-6.1,6.37-9.4,9.3-3.29,2.93-6.78,5.62-10.28,8.28l-.05-.07v-.02Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-979588ef-ac0a-4826-b7ed-ff84c956a21f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.78,338.07c.79,7.8,1.86,15.58,3.21,23.3,1.33,7.72,2.94,15.39,4.93,22.95,2.01,7.56,4.5,14.97,7.41,22.18,2.89,7.21,6.47,14.21,11.64,20.11l-.13.13c-2.99-2.58-5.48-5.72-7.64-9.04-2.17-3.32-3.93-6.88-5.56-10.49-3.18-7.26-5.31-14.89-7.14-22.54-3.66-15.32-5.8-30.94-6.91-46.59l.18-.02h.01Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-a3a517c9-6f44-4172-9959-fbb3fdd7b395)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m51.55,311.89c9.28-9.88,18.7-19.64,28.55-28.97,9.85-9.32,20.13-18.23,31.16-26.18,11.02-7.93,22.78-14.93,35.31-20.26,6.25-2.7,12.7-4.93,19.25-6.78,6.56-1.82,13.25-3.2,19.99-4.17,13.5-1.87,27.21-2.06,40.77-.81,13.57,1.25,26.97,3.84,40.1,7.32,13.15,3.43,26.02,7.84,38.67,12.75,3.15,1.14,6.45,1.98,9.72,2.82,3.28.81,6.59,1.55,9.93,2.02,6.71.95,13.44,1.8,20.12,2.95l-.03.18c-6.69-1.05-13.43-1.81-20.16-2.67-3.38-.43-6.71-1.13-10.01-1.9-3.3-.8-6.59-1.59-9.84-2.7-12.76-4.54-25.68-8.63-38.81-11.91-6.56-1.64-13.17-3.05-19.82-4.23-6.65-1.2-13.34-2.11-20.06-2.74-13.43-1.29-27-1.25-40.38.48-6.68.9-13.32,2.2-19.83,3.96-6.5,1.79-12.91,3.95-19.13,6.59-12.47,5.2-24.21,12.07-35.24,19.89-11.04,7.83-21.39,16.6-31.32,25.82-9.93,9.22-19.44,18.89-28.82,28.68l-.13-.13h.01Z",
    style: {
      fill: "url(#support_whiteboard_icon_svg__uuid-306cd40b-e3df-4a68-8a4e-bd4773090d8c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m373.25,235.16c.65,1.56,2.12,3.26,1.99,5.49-.12,2.07-1.93,9.76-3.52,13.76,0,0,1.17-11.32,1.11-14.77-.03-1.68.43-4.49.43-4.49h0Z",
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.85,143.29c-1.05-2.14-2.1-4.23-3.57-5.96-.37-.45-.79-1.04-1.07-1.69-.72-1.76-.81-3.73-.98-5.55-.34-4.79-.29-9.45-.45-14.17-.22-9.42-.74-18.83-1.83-28.19-2.11-18.76-6.1-37.32-8.23-56.09l.13.12c.08.04.17-.15.13-.08v.06l-.03.08-.04.17-.08.34-.15.69c-.64,2.92-1.38,6.38-2.04,9.29-.02.07-.05.2-.06.26,0,.03-.02.06-.03.09l-.04.06s-.11.04-.14.03c-.17-.04-.09-.33.08-.26-.02,0-.09,0-.13.02-.04.05-.04.07-.03.04v-.06s.03-.08.03-.08l.04-.17c.66-2.91,1.4-6.37,2.03-9.29l.15-.69.08-.34.04-.17.02-.09v-.04s0-.02,0-.02h0s.07-.15.14-.12c3.1,18.59,7.41,37.22,10.08,56,1.91,14.07,3.15,28.31,2.79,42.52.07,2.21-.3,4.42.95,6.36,1.29,2.13,1.96,4.51,2.43,6.83.04.15-.2.23-.26.09h.03Z",
    style: {
      fill: "#c43dd9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m152.53,42.69c-2.09,4.68-3.91,9.47-5.83,14.22-6.02,14.09-12.46,28.12-16.22,43.02-2.6,9.84-3.82,20.03-3.1,30.13.77,10.1,2.72,20.18,4.99,30.06l-1.15-1.03c7.39,1.08,15.07.36,22.11-2.18,7.12-2.55,13.4-7.32,17.52-13.73.08-.15.32,0,.24.14-3.53,6.98-9.86,12.35-17.06,15.36-7.26,3.08-15.35,3.96-23.16,3.12-.57-.06-1.01-.47-1.14-1-2.54-10.04-4.33-20.24-4.81-30.62-1.28-26.2,10.34-50.42,21.15-73.54,2.05-4.69,3.99-9.45,6.21-14.07.07-.16.33-.04.25.12h0Z",
    style: {
      fill: "#c43dd9"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportWhiteboardIcon);
export default __webpack_public_path__ + "static/media/support_whiteboard_icon.eeb97cec0854470fafe156b6d291bedc.svg";
export { ForwardRef as ReactComponent };